"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var NestedIcon_1 = __importDefault(require("../../../Icon/NestedIcon"));
var RemovableDropdown_1 = __importDefault(require("../../inputs/RemovableDropdown"));
var Specializace_1 = __importStar(require("./Specializace"));
var utils_1 = require("./utils");
var Odvetvi = function (_a) {
    var specializace = _a.specializace, odvetvi = _a.odvetvi, onChange = _a.onChange, onRemove = _a.onRemove, value = _a.value, disableAdd = _a.disableAdd, specializaceFilter = _a.specializaceFilter, onRemoveAny = _a.onRemoveAny, prioritni = _a.prioritni, obor = _a.obor, readOnly = _a.readOnly, initialSpecs = _a.initialSpecs;
    var treeIds = utils_1.getTreeIds(value);
    var usedIds = ramda_1.without([odvetvi.idSpecializace], treeIds);
    var options = ramda_1.pipe(utils_1.filterAvailable(usedIds), utils_1.mapSpecializaceToOptions)(specializace);
    var AddSpecializaceAction = function () {
        onChange(ramda_1.over(utils_1.podrizeneLens, ramda_1.append({}), odvetvi));
    };
    var handleRemoveSpecializace = function (index) {
        if (index < odvetvi.podrizene.length) {
            if (onRemoveAny)
                onRemoveAny(odvetvi.podrizene[index].idSpecializace);
            onChange(__assign(__assign({}, odvetvi), { podrizene: ramda_1.remove(index, 1, odvetvi.podrizene) }));
        }
    };
    var useFilter = function (opts) {
        var filtered = specializaceFilter ? opts.filter(function (o) { return specializaceFilter.includes(o.value); }) : opts;
        return filtered;
    };
    var podrizene = utils_1.isAddDisabled(disableAdd, 'specializace') ? odvetvi.podrizene : ramda_1.append({}, odvetvi.podrizene);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Specializace_1.StyledRemovableDiv, { readOnly: readOnly },
            react_1.default.createElement(RemovableDropdown_1.default, { leftIcon: react_1.default.createElement(NestedIcon_1.default, { active: true }), name: "odvetvi-" + odvetvi.idSpecializace, value: odvetvi.idSpecializace, onChange: function (odvetviId) {
                    var selectedOdvetvi = utils_1.findByIdSpecializace(odvetviId || null, specializace);
                    if (selectedOdvetvi && odvetviId !== odvetvi.idSpecializace) {
                        onChange(ramda_1.set(utils_1.podrizeneLens, [], selectedOdvetvi));
                    }
                }, placeholder: "Vyberte odv\u011Btv\u00ED", loadOptions: function () { return Promise.resolve(useFilter(options)); }, onRemove: onRemove, showAdd: !readOnly, addString: "+ Specializace", onAdd: AddSpecializaceAction, disabled: readOnly, showRemove: !readOnly, readOnly: readOnly })),
        ramda_1.addIndex(ramda_1.map)(function (spec, index) { return (react_1.default.createElement(Specializace_1.default
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: (spec === null || spec === void 0 ? void 0 : spec.idSpecializace) || "create-" + index, parentId: odvetvi.idSpecializace || (obor === null || obor === void 0 ? void 0 : obor.idSpecializace), value: spec, treeIds: treeIds, specializaceFilter: specializaceFilter, rightIcon: react_1.default.createElement("span", null), onChange: function (selected) {
                var _a;
                if (!selected) {
                    return handleRemoveSpecializace(index);
                }
                var selectedSpecializace = ramda_1.set(utils_1.podrizeneLens, undefined, selected);
                if (index >= odvetvi.podrizene.length) {
                    return onChange(__assign(__assign({}, odvetvi), { podrizene: ramda_1.append(selectedSpecializace, odvetvi.podrizene) }));
                }
                onChange(__assign(__assign({}, odvetvi), { podrizene: ramda_1.set(ramda_1.lensIndex(index), selectedSpecializace, odvetvi.podrizene), idSpecializace: (_a = odvetvi.idSpecializace) !== null && _a !== void 0 ? _a : selectedSpecializace.idNadrazene }));
            }, prioritni: prioritni, readOnly: readOnly, initialSpecs: initialSpecs })); }, utils_1.viewPodrizene(odvetvi))));
};
Odvetvi.defaultProps = {
    disableAdd: false,
    specializaceFilter: undefined,
    onRemoveAny: undefined,
    prioritni: undefined,
    obor: undefined,
    readOnly: undefined,
};
exports.default = Odvetvi;
